import { z } from 'zod';

export const dapiConfigurationSchema = z.object({
  validConnection: z.boolean(),
});
